module.exports = __webpack_public_path__ + "static/media/boss_clothes.87f06bfd.png";